import { CategoryInterface } from '../../../services/exports/Interfaces';
import classnames from 'classnames';

interface Props {
  key: string;
  itemId?: string;
  category?: CategoryInterface;
  focusedCategoryId?: number;
  onClick: (id?: number) => void;
}

export default function Card(props: Props) {
  const { category, focusedCategoryId, onClick } = props;
  const active = focusedCategoryId === category?.id;

  const labelContainer = classnames(
    'cursor-pointer relative px-sm h-8 rounded-full flex justify-center items-center transition-colors',
    active
      ? 'border-2 border-brand-primary bg-brand-background-secondary'
      : 'border border-brand-border hover:border-brand-primary',
  );
  const titleStyle = classnames(
    'relative whitespace-nowrap text-sm select-none uppercase',
    active && 'text-brand-primary font-medium',
    !active && 'text-muted-foreground',
  );

  return (
    <div className={labelContainer} onClick={() => onClick(category?.id)} key={category?.id}>
      <p className={titleStyle}>{category?.name}</p>
    </div>
  );
}
